import centerImage from "../../assets/interview.png";
import { FaUserTimes, FaGlobe, FaClock, FaBullhorn, FaLightbulb, FaSun, FaAward } from "react-icons/fa";
import graphicImage from "../../assets/download.png";
import bg from "../../assets/BG.jpg"
import { useEffect } from "react";
export default function Placement() {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top of the page
    }, []);
 
    return (
        <div className="w-full overflow-x-hidden">
            <div
                className="w-full min-h-[400px] md:h-[500px] bg-cover bg-center relative flex flex-col md:flex-row items-center justify-center px-4 sm:px-8 md:px-20 text-white"
                style={{ backgroundImage: `url(${bg})` }}
            >
                <div className="flex w-[90%] xl:justify-between relative items-center">
                <div className="w-full md:max-w-[550px]">
                    <h1 className="text-4xl md:text-5xl font-bold text-center md:text-left">
                        NEXTGEN{" "}
                        <span
                            className="bg-yellow-400 text-white tracking-widest px-3 py-1 rounded-xl inline-block rotate-[-2deg] mt-2 md:mt-0"
                            style={{
                                fontFamily: "Luckiest Guy",
                            }}
                        >
                            PLACEMENT
                        </span>
                    </h1>
                    <p
                        className="mt-6 text-sm leading-relaxed text-center md:text-left"
                        style={{ fontFamily: "Montserrat" }}
                    >
                        NextGen Placement delivers pre-vetted, industry-ready talent equipped with technical skills, leadership potential, and executive presence. We bridge the skills gap by providing interview-ready candidates trained in real-world problem-solving and strategic thinking reducing your hiring time while ensuring quality. Partner with us to build a pipeline of future-ready professionals who will drive innovation and growth in your organization from day one.
                    </p>
                </div>
 
                <div className="absolute right-[-20px] top-[-79px] hidden lg:block text-center md:text-left">
                    <img
                        src={graphicImage}
                        alt="Placement Graphic"
                        className="h-[300px] md:h-[450px] object-contain"
                    />
                </div>
                </div>
            </div>
            <section className="bg-white py-12 px-4 md:px-12 lg:px-20 text-center  overflow-hidden">
                <h2
                    className="text-2xl md:text-3xl font-bold text-blue-600 mb-4"
                    style={{ fontFamily: "Montserrat" }}
                >
                    The Corporate Hiring Challenge
                </h2>
                <p
                    className="text-gray-600 text-base md:text-lg mb-1"
                    style={{ fontFamily: "Montserrat" }}
                >
                    Finding candidates who are truly job-ready is time-consuming and expensive.
                </p>
                <p
                    className="text-gray-600 text-base md:text-lg mb-10"
                    style={{ fontFamily: "Montserrat" }}
                >
                    Traditional hiring often delivers:
                </p>
 
                <div className="flex flex-col md:flex-row items-center justify-center gap-6 px-4 sm:px-6 md:px-8 py-8">
 
                    <div className="flex flex-col gap-6 md:gap-7 text-left md:text-right w-full md:w-1/3">
                        <div className="flex flex-row-reverse md:flex-row items-center justify-end md:justify-start gap-4">
                            <p className="text-black text-sm sm:text-base leading-relaxed font-[Montserrat]">
                                Unvetted applicants who lack critical skills
                            </p>
                            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full border-2 border-orange-500 text-orange-500">
                                <FaLightbulb className="text-lg" />
                            </div>
                        </div>
 
                        <div className="flex flex-row-reverse md:flex-row items-center justify-end md:justify-start gap-4">
                            <p className="text-black text-sm sm:text-base leading-relaxed font-[Montserrat]">
                                Mismatched talent that doesn't align with your culture
                            </p>
                            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full border-2 border-orange-500 text-orange-500">
                                <FaGlobe className="text-lg" />
                            </div>
                        </div>
                    </div>
 
 
                    <div className="w-[180px] h-[180px] sm:w-[230px] sm:h-[230px] border-[15px] sm:border-[20px] border-gray-200 rounded-full overflow-hidden shadow-lg mx-auto flex-shrink-0">
                        <img
                            src={centerImage}
                            alt="Interview"
                            className="w-full h-full object-cover"
                        />
                    </div>
 
 
                    <div className="flex flex-col gap-6 md:gap-7 text-left md:text-left w-full md:w-1/3">
                        <div className="flex items-center justify-start gap-4">
                            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full border-2 border-orange-500 text-orange-500">
                                <FaSun className="text-lg" />
                            </div>
                            <p className="text-black text-sm sm:text-base leading-relaxed font-[Montserrat]">
                                Lengthy onboarding periods for fresh graduates
                            </p>
                        </div>
 
                        <div className="flex items-center justify-start gap-4">
                            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full border-2 border-orange-500 text-orange-500">
                                <FaAward className="text-lg" />
                            </div>
                            <p className="text-black text-sm sm:text-base leading-relaxed font-[Montserrat]">
                                Weak employer branding in competitive talent markets
                            </p>
                        </div>
                    </div>
                </div>
            </section>
 
        </div>
        // <div className="relative overflow-x-hidden">
 
        //     <div
        //         className="w-full h-[60vh] md:min-h-[60vh] bg-cover bg-center bg-no-repeat hidden md:block"
        //         style={{
        //             backgroundImage: `url(${desktopbg})`,
        //         }}
        //     >
        //         <div className="flex flex-col md:flex-row items-center justify-between px-6 md:px-20 py-10 h-full">
 
        //             <div className="md:w-1/2 w-full flex justify-center mb-6 lg:mb-0"></div>
 
 
        //             <div className="md:w-1/2 w-full text-center md:text-left md:mt-[30px] lg:mt-[130px]">
        //                 <div className="flex items-center justify-center lg:justify-center flex-wrap">
        //                     <div
        //                         className="font-bold text-5xl text-black"
        //                         style={{ fontFamily: "Montserrat" }}
        //                     >
        //                         NEXTGEN
        //                     </div>
        //                     <img
        //                         src="https://dbqa318yoj3nn.cloudfront.net/juniors.png"
        //                         className="w-[30%] max-w-[200px]"
        //                         alt="Juniors"
        //                     />
        //                 </div>
 
        //                 <div className="flex gap-2 p-4 justify-center md:justify-center mt-5 flex-wrap">
        //                     <div
        //                         className="bg-pink-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-pink-400"
        //                         style={{ fontFamily: "Montserrat" }}
        //                     >
        //                         Think
        //                     </div>
        //                     <div
        //                         className="bg-orange-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-orange-400"
        //                         style={{ fontFamily: "Montserrat" }}
        //                     >
        //                         Imagine
        //                     </div>
        //                     <div
        //                         className="bg-yellow-500 text-black font-bold px-4 py-2 rounded-lg hover:bg-yellow-600"
        //                         style={{ fontFamily: "Montserrat" }}
        //                     >
        //                         Achieve
        //                     </div>
        //                 </div>
 
        //                 <div className="mt-4 px-2">
        //                     <p
        //                         className="text-white text-center md:text-[14px] lg:text-[16px] md:text-center"
        //                         style={{ fontFamily: "Poppins" }}
        //                     >
        //                         A program where curiosity meets creativity in an immersive,
        //                         theme-based educational journey for Grades 1–5. Our
        //                         revolutionary approach replaces rote learning with dynamic,
        //                         interdisciplinary exploration, ensuring children grasp concepts
        //                         in a way that is engaging, relevant, and future-ready. With
        //                         hands-on projects, real-world applications, and interactive
        //                         storytelling, we cultivate young minds to think, question, and
        //                         innovate.
        //                     </p>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
 
 
        //     <div
        //         className="w-full h-auto min-h-[60vh] bg-cover bg-center bg-no-repeat md:hidden"
        //         style={{
        //             backgroundImage: `url(${mobilebg})`,
        //         }}
        //     >
        //         <div className="flex flex-col items-center justify-between px-6 py-10">
        //             <div className="w-full text-center">
        //                 <div className="flex items-center justify-center flex-wrap">
        //                     <div
        //                         className="font-bold text-5xl text-black"
        //                         style={{ fontFamily: "Montserrat" }}
        //                     >
        //                         NEXTGEN
        //                     </div>
        //                     <img
        //                         src="https://dbqa318yoj3nn.cloudfront.net/juniors.png"
        //                         className="w-[30%] max-w-[200px]"
        //                         alt="Juniors"
        //                     />
        //                 </div>
 
        //                 <div className="flex gap-2 p-4 justify-center mt-5 flex-wrap">
        //                     <div
        //                         className="bg-pink-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-pink-400"
        //                         style={{ fontFamily: "Montserrat" }}
        //                     >
        //                         Think
        //                     </div>
        //                     <div
        //                         className="bg-orange-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-orange-400"
        //                         style={{ fontFamily: "Montserrat" }}
        //                     >
        //                         Imagine
        //                     </div>
        //                     <div
        //                         className="bg-yellow-500 text-black font-bold px-4 py-2 rounded-lg hover:bg-yellow-600"
        //                         style={{ fontFamily: "Montserrat" }}
        //                     >
        //                         Achieve
        //                     </div>
        //                 </div>
 
        //                 <div className="mt-4 px-2">
        //                     <p
        //                         className="text-white text-center text-[14px]"
        //                         style={{ fontFamily: "Poppins" }}
        //                     >
        //                         A program where curiosity meets creativity in an immersive,
        //                         theme-based educational journey for Grades 1–5. Our
        //                         revolutionary approach replaces rote learning with dynamic,
        //                         interdisciplinary exploration, ensuring children grasp concepts
        //                         in a way that is engaging, relevant, and future-ready. With
        //                         hands-on projects, real-world applications, and interactive
        //                         storytelling, we cultivate young minds to think, question, and
        //                         innovate.
        //                     </p>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
 
        // </div>
    );
}
 